import { Dayjs } from 'dayjs';

import { LOCALES } from 'src/interfaces/i18n.types';

const monthFormat =
  'Января_Февраля_Марта_Апреля_Мая_Июня_Июля_Августа_Сентября_Октября_Ноября_Декабря'.split(
    '_',
  );
const monthStandalone =
  'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split(
    '_',
  );

const monthShortFormat =
  'Янв._Февр._Март_Апр._Мая_Июня_Июля_Авг._Сент._Окт._Нояб._Дек.'.split('_');
const monthShortStandalone =
  'Янв._Февр._Март_Апр._Май_Июнь_Июль_Авг._Сент._Окт._Нояб._Дек.'.split('_');

const MONTHS_IN_FORMAT = /D[oD]?(\[[^[\]]*\]|\s)+MMMM?/;

const months = (dayjsInstance: Dayjs, format: string) => {
  if (MONTHS_IN_FORMAT.test(format)) {
    return monthFormat[dayjsInstance.month()];
  }
  return monthStandalone[dayjsInstance.month()];
};
months.s = monthStandalone;
months.f = monthFormat;

const monthsShort = (dayjsInstance: Dayjs, format: string) => {
  if (MONTHS_IN_FORMAT.test(format)) {
    return monthShortFormat[dayjsInstance.month()];
  }
  return monthShortStandalone[dayjsInstance.month()];
};
monthsShort.s = monthShortStandalone;
monthsShort.f = monthShortFormat;

const ruLocale: Partial<ILocale> = {
  name: LOCALES.RU,
  weekdays:
    'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
  weekdaysShort: 'Вск_Пнд_Втр_Срд_Чтв_Птн_Сбт'.split('_'),
  weekdaysMin: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
  //  @ts-expect-error months also can be a function
  months,
  //  @ts-expect-error months also can be a function
  monthsShort,
};

export { ruLocale };
